/* eslint-disable indent */
export const fileTypes = (value) => {
    if (!value) {
        return true
    }
    const allowTypes = [
        // PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        'document/pdf',
        // DOC
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // EXCEL
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // IMAGE
        'image/jpeg',
        'image/gif',
        'image/png',
        // ZIP
        'application/x-compressed',
        'application/x-zip-compressed',
        'application/zip',
        'multipart/x-zip',
        'application/octet-stream'
    ]
    return allowTypes.includes(value.type)
}
